"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuery = useQuery;
exports.capitalizeFirstLetter = capitalizeFirstLetter;
exports.isApplicationProfilePolicyPath = exports.getCapitalisedString = exports.getPolicyUserTagsMapById = exports.getPolicyUsersMapById = exports.blue60 = exports.otpSeedType = exports.otpName = exports.otpType = exports.SecretActions = exports.getDaysString = exports.getFileName = exports.getParentString = exports.getMembers = exports.getTimeInHMFromMinutes = exports.getApplicationName = exports.nameCharacterValidation = exports.fetchMembers = exports.resetMembers = exports.getFormattedLocalTimeString = exports.getFormattedLocalDateString = exports.getLocalDateTime = exports.getRequiredString = exports.convertTimeToCurrentTimezone = exports.isInitial = exports.isError = exports.isSuccess = exports.isLoading = exports.getHeightFromTop = exports.getQueryParamsFromUrl = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _moment = _interopRequireDefault(require("moment"));

var _commonConstants = require("./common-constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getQueryParamsFromUrl = function getQueryParamsFromUrl(apiUrl, param) {
  var url = new URL(apiUrl);
  var urlParams = new URLSearchParams(url.search);
  return urlParams.get(param);
};

exports.getQueryParamsFromUrl = getQueryParamsFromUrl;

var getHeightFromTop = function getHeightFromTop(element) {
  var totalHeightAboveElement = element === null || element === void 0 ? void 0 : element.getBoundingClientRect().top;
  var elementTopPadding = Number(window.getComputedStyle(element, null).getPropertyValue('padding-top').replace('px', ''));
  var elementBottomPadding = Number(window.getComputedStyle(element, null).getPropertyValue('padding-bottom').replace('px', ''));
  return totalHeightAboveElement + elementBottomPadding + elementTopPadding;
};

exports.getHeightFromTop = getHeightFromTop;

function useQuery() {
  var _useLocation = (0, _reactRouter.useLocation)(),
      search = _useLocation.search;

  return _react.default.useMemo(function () {
    return new URLSearchParams(search);
  }, [search]);
}

var isLoading = function isLoading(value) {
  return value === _commonConstants.RESOURCE_STATUS.LOADING;
};

exports.isLoading = isLoading;

var isSuccess = function isSuccess(value) {
  return value === _commonConstants.RESOURCE_STATUS.SUCCESS;
};

exports.isSuccess = isSuccess;

var isError = function isError(value) {
  return value === _commonConstants.RESOURCE_STATUS.ERROR;
};

exports.isError = isError;

var isInitial = function isInitial(value) {
  return value === _commonConstants.RESOURCE_STATUS.INITIAL;
};

exports.isInitial = isInitial;

var convertTimeToCurrentTimezone = function convertTimeToCurrentTimezone(UTCString) {
  return (0, _moment.default)(UTCString).format(_commonConstants.dateFormat);
};

exports.convertTimeToCurrentTimezone = convertTimeToCurrentTimezone;

var getRequiredString = function getRequiredString(parents) {
  if ((parents === null || parents === void 0 ? void 0 : parents.length) === 0) return '/';
  var parentsString = '';

  for (var i in parents) {
    parentsString += "/".concat(parents[i].label);
  }

  return parentsString;
};

exports.getRequiredString = getRequiredString;

var getLocalDateTime = function getLocalDateTime(dateStr) {
  return new Date(_moment.default.utc(dateStr).local());
};

exports.getLocalDateTime = getLocalDateTime;

var getFormattedLocalDateString = function getFormattedLocalDateString(dateStr) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _commonConstants.viewDateFormat;
  return _moment.default.utc(dateStr).local().format(dateFormat);
};

exports.getFormattedLocalDateString = getFormattedLocalDateString;

var getFormattedLocalTimeString = function getFormattedLocalTimeString(dateStr) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _commonConstants.viewDateFormat;

  var timeString = _moment.default.utc(dateStr).local().format(dateFormat).toString();

  timeString = timeString.substring(timeString.indexOf(' ') + 1);
  return timeString;
};

exports.getFormattedLocalTimeString = getFormattedLocalTimeString;

var resetMembers = function resetMembers(validationHook) {
  validationHook.handleChange(validationHook.names.allUser, false);
  validationHook.handleChange(validationHook.names.allGroup, false);
  validationHook.handleChange(validationHook.names.allToken, false);
  validationHook.handleChange(validationHook.names.allServiceIdentity, false);
  validationHook.handleChange(validationHook.names.user, []);
  validationHook.handleChange(validationHook.names.group, []);
  validationHook.handleChange(validationHook.names.serviceIdentity, []);
  validationHook.handleChange(validationHook.names.token, []);
};

exports.resetMembers = resetMembers;

var fetchMembers = function fetchMembers(members, action) {
  if (!members.length) return;

  if (members.length >= 1 && members[0].id != '*') {
    action();
  }
};

exports.fetchMembers = fetchMembers;

var nameCharacterValidation = function nameCharacterValidation(value) {
  var nameRegex = /[a-zA-Z_\- 0-9]+/;
  var compareString = value || '';
  var matches = compareString.match(nameRegex); // matches array should only have one match i.e the name

  return Boolean(matches) && matches.length === 1 && matches[0].length === compareString.length;
};

exports.nameCharacterValidation = nameCharacterValidation;

function capitalizeFirstLetter(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

var getApplicationName = function getApplicationName(resources, applicationsListData) {
  return resources.map(function (value) {
    if (value === '*') return value;else {
      var _applicationsListData;

      return applicationsListData === null || applicationsListData === void 0 ? void 0 : (_applicationsListData = applicationsListData.find(function (application) {
        return (application === null || application === void 0 ? void 0 : application.appContainerId) === value;
      })) === null || _applicationsListData === void 0 ? void 0 : _applicationsListData.applicationName;
    }
  });
};

exports.getApplicationName = getApplicationName;

var getTimeInHMFromMinutes = function getTimeInHMFromMinutes(minutes, translatedStrings) {
  var SIXTY = 60;
  var hours = parseInt(minutes / SIXTY);
  var minute = minutes - hours * SIXTY;
  return "".concat(hours ? translatedStrings.hours(hours) : '', " ").concat(minute ? translatedStrings.minutes(minute) : '', " ");
};

exports.getTimeInHMFromMinutes = getTimeInHMFromMinutes;

var getMemberObjects = function getMemberObjects(members, membersData, idProperty) {
  var actualMembers = [];

  if (members) {
    var actualMember = null;

    var _loop = function _loop(itr) {
      actualMember = membersData === null || membersData === void 0 ? void 0 : membersData.find(function (member) {
        return member[idProperty] === members[itr];
      });
      if (actualMember) actualMembers.push(actualMember);
    };

    for (var itr = 0; itr < members.length; itr++) {
      _loop(itr);
    }

    if (!actualMember && members.length === 1 && members[0].length === 1) {
      actualMembers.push('*');
    }
  }

  return actualMembers;
};
/* Exported this function to reuse it under PolicyViewApprovals */


var getMembers = function getMembers(members, fetchedMembers, isApproval) {
  var _members$users, _members$serviceIdent, _members$tags, _members$tokens;

  var actualUsers = [],
      actualGroups = [],
      actualServiceIdentities = [],
      actualTokens = [];
  var users = isApproval ? members === null || members === void 0 ? void 0 : members.users : members === null || members === void 0 ? void 0 : (_members$users = members.users) === null || _members$users === void 0 ? void 0 : _members$users.map(function (_ref) {
    var id = _ref.id;
    return id;
  });
  var serviceIdentities = members === null || members === void 0 ? void 0 : (_members$serviceIdent = members.serviceIdentities) === null || _members$serviceIdent === void 0 ? void 0 : _members$serviceIdent.map(function (_ref2) {
    var id = _ref2.id;
    return id;
  });
  var tags = isApproval ? members === null || members === void 0 ? void 0 : members.tags : members === null || members === void 0 ? void 0 : (_members$tags = members.tags) === null || _members$tags === void 0 ? void 0 : _members$tags.map(function (_ref3) {
    var id = _ref3.id;
    return id;
  });
  var tokens = members === null || members === void 0 ? void 0 : (_members$tokens = members.tokens) === null || _members$tokens === void 0 ? void 0 : _members$tokens.map(function (_ref4) {
    var id = _ref4.id;
    return id;
  });
  actualUsers = getMemberObjects(users, fetchedMembers === null || fetchedMembers === void 0 ? void 0 : fetchedMembers.users, 'userId');
  actualGroups = getMemberObjects(tags, fetchedMembers === null || fetchedMembers === void 0 ? void 0 : fetchedMembers.groups, 'userTagId');
  actualTokens = getMemberObjects(tokens, fetchedMembers === null || fetchedMembers === void 0 ? void 0 : fetchedMembers.tokens, 'id');
  actualServiceIdentities = getMemberObjects(serviceIdentities, fetchedMembers === null || fetchedMembers === void 0 ? void 0 : fetchedMembers.serviceIdentities, 'userId');
  return {
    users: actualUsers && Boolean(actualUsers.length) ? actualUsers : undefined,
    tags: actualGroups && Boolean(actualGroups.length) ? actualGroups : undefined,
    tokens: actualTokens && Boolean(actualTokens.length) ? actualTokens : undefined,
    serviceIdentities: actualServiceIdentities && Boolean(actualServiceIdentities.length) ? actualServiceIdentities : undefined
  };
};

exports.getMembers = getMembers;

var getParentString = function getParentString(parents) {
  if ((parents === null || parents === void 0 ? void 0 : parents.length) === 0) return '/';
  var parentsString = '';

  for (var i in parents) {
    parentsString += "/".concat(parents[i].label);
  }

  return parentsString;
};

exports.getParentString = getParentString;

var getFileName = function getFileName(secretDetailData, sstFileParameter) {
  return secretDetailData.value && Object.keys(secretDetailData.value).length && Object.hasOwnProperty.call(secretDetailData.value, sstFileParameter.name) ? secretDetailData.value[sstFileParameter.name] : null;
};

exports.getFileName = getFileName;

var getDaysString = function getDaysString(days) {
  var selectedDays = _toConsumableArray(days);

  if (selectedDays.length === 0) {
    return '';
  } else if (selectedDays.length === 1) {
    return selectedDays[0];
  } else {
    return "".concat(selectedDays.splice(0, selectedDays.length - 1).join(", "), "\n      and ").concat(selectedDays[selectedDays.length - 1]);
  }
};

exports.getDaysString = getDaysString;
var SecretActions = ['authz.policy.create', 'authz.policy.delete', 'authz.policy.list', 'authz.policy.read', 'authz.policy.update', 'sm.node.create', 'sm.node.delete', 'sm.node.list', 'sm.secret.read', 'sm.secret.update'];
exports.SecretActions = SecretActions;
var otpType = 'otp';
exports.otpType = otpType;
var otpName = 'OTP';
exports.otpName = otpName;
var otpSeedType = 'otpSeed';
exports.otpSeedType = otpSeedType;
var blue60 = '#4573D2';
exports.blue60 = blue60;

var getPolicyUsersMapById = function getPolicyUsersMapById() {
  var _policyData$members, _policyCondition, _policyCondition$appr, _policyCondition$appr2;

  var policyData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if ((0, _isEmpty.default)(policyData)) {
    return [];
  }

  var usersMap = [];

  if (!(0, _isEmpty.default)(policyData === null || policyData === void 0 ? void 0 : (_policyData$members = policyData.members) === null || _policyData$members === void 0 ? void 0 : _policyData$members.users)) {
    var _policyData$members2;

    usersMap = policyData === null || policyData === void 0 ? void 0 : (_policyData$members2 = policyData.members) === null || _policyData$members2 === void 0 ? void 0 : _policyData$members2.users;
  }

  var policyCondition = policyData === null || policyData === void 0 ? void 0 : policyData.condition;

  if (typeof (policyData === null || policyData === void 0 ? void 0 : policyData.condition) === 'string') {
    var _policyData$condition;

    if (!(policyData !== null && policyData !== void 0 && (_policyData$condition = policyData.condition) !== null && _policyData$condition !== void 0 && _policyData$condition.length)) {
      return usersMap;
    }

    policyCondition = JSON.parse(policyData === null || policyData === void 0 ? void 0 : policyData.condition);
  }

  if (!(0, _isEmpty.default)((_policyCondition = policyCondition) === null || _policyCondition === void 0 ? void 0 : (_policyCondition$appr = _policyCondition.approval) === null || _policyCondition$appr === void 0 ? void 0 : (_policyCondition$appr2 = _policyCondition$appr.approvers) === null || _policyCondition$appr2 === void 0 ? void 0 : _policyCondition$appr2.userIds)) {
    var _policyCondition2, _policyCondition2$app, _policyCondition2$app2, _policyCondition2$app3;

    var approversUsers = (_policyCondition2 = policyCondition) === null || _policyCondition2 === void 0 ? void 0 : (_policyCondition2$app = _policyCondition2.approval) === null || _policyCondition2$app === void 0 ? void 0 : (_policyCondition2$app2 = _policyCondition2$app.approvers) === null || _policyCondition2$app2 === void 0 ? void 0 : (_policyCondition2$app3 = _policyCondition2$app2.userIds) === null || _policyCondition2$app3 === void 0 ? void 0 : _policyCondition2$app3.map(function (userId) {
      return {
        id: userId
      };
    });
    usersMap = [].concat(_toConsumableArray(usersMap), _toConsumableArray(approversUsers));
  }

  return usersMap;
};

exports.getPolicyUsersMapById = getPolicyUsersMapById;

var getPolicyUserTagsMapById = function getPolicyUserTagsMapById() {
  var _policyData$members3, _policyCondition3, _policyCondition3$app, _policyCondition3$app2;

  var policyData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if ((0, _isEmpty.default)(policyData)) {
    return [];
  }

  var tagsMap = [];

  if (!(0, _isEmpty.default)(policyData === null || policyData === void 0 ? void 0 : (_policyData$members3 = policyData.members) === null || _policyData$members3 === void 0 ? void 0 : _policyData$members3.tags)) {
    var _policyData$members4;

    tagsMap = policyData === null || policyData === void 0 ? void 0 : (_policyData$members4 = policyData.members) === null || _policyData$members4 === void 0 ? void 0 : _policyData$members4.tags;
  }

  var policyCondition = policyData === null || policyData === void 0 ? void 0 : policyData.condition;

  if (typeof (policyData === null || policyData === void 0 ? void 0 : policyData.condition) === 'string') {
    var _policyData$condition2;

    if (!(policyData !== null && policyData !== void 0 && (_policyData$condition2 = policyData.condition) !== null && _policyData$condition2 !== void 0 && _policyData$condition2.length)) {
      return tagsMap;
    }

    policyCondition = JSON.parse(policyData === null || policyData === void 0 ? void 0 : policyData.condition);
  }

  if (!(0, _isEmpty.default)((_policyCondition3 = policyCondition) === null || _policyCondition3 === void 0 ? void 0 : (_policyCondition3$app = _policyCondition3.approval) === null || _policyCondition3$app === void 0 ? void 0 : (_policyCondition3$app2 = _policyCondition3$app.approvers) === null || _policyCondition3$app2 === void 0 ? void 0 : _policyCondition3$app2.tags)) {
    var _policyCondition4, _policyCondition4$app, _policyCondition4$app2, _policyCondition4$app3;

    var approversUsers = (_policyCondition4 = policyCondition) === null || _policyCondition4 === void 0 ? void 0 : (_policyCondition4$app = _policyCondition4.approval) === null || _policyCondition4$app === void 0 ? void 0 : (_policyCondition4$app2 = _policyCondition4$app.approvers) === null || _policyCondition4$app2 === void 0 ? void 0 : (_policyCondition4$app3 = _policyCondition4$app2.tags) === null || _policyCondition4$app3 === void 0 ? void 0 : _policyCondition4$app3.map(function (tagId) {
      return {
        id: tagId
      };
    });
    tagsMap = [].concat(_toConsumableArray(tagsMap), _toConsumableArray(approversUsers));
  }

  return tagsMap;
};

exports.getPolicyUserTagsMapById = getPolicyUserTagsMapById;

var getCapitalisedString = function getCapitalisedString(string) {
  var _string$charAt, _string$slice;

  return "".concat(string === null || string === void 0 ? void 0 : (_string$charAt = string.charAt(0)) === null || _string$charAt === void 0 ? void 0 : _string$charAt.toUpperCase()).concat(string === null || string === void 0 ? void 0 : (_string$slice = string.slice(1)) === null || _string$slice === void 0 ? void 0 : _string$slice.toLowerCase());
};

exports.getCapitalisedString = getCapitalisedString;

var isApplicationProfilePolicyPath = function isApplicationProfilePolicyPath() {
  var regex = /^\/admin\/applications\/[^/]+\/profiles\/[^/]+\/details\/policies\/manage/;
  return regex.test(location.pathname);
};

exports.isApplicationProfilePolicyPath = isApplicationProfilePolicyPath;